/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from 'react-router';
import Button from '../../components/Button';
import * as app from "../../services/AppService";
import * as http from "../../services/http";
import { logout } from "../../store/auth";
import ColorMode from "../ColorMode";
import Language from "../Language";
import { menuData } from "./data";
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";
import Marquee from "react-fast-marquee"
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Nav from "react-bootstrap/Nav";
import Dropdown from 'react-bootstrap/Dropdown';
import './UserNavBar.css';

interface IMessageCountProps {
    msgCount: number;
    openMessages: () => void;
    className?: string;
    style?: object;
    iconClass?: string;
    position?: string
}
interface IChildProps {
    id: number
    name: string
}
interface IMenuItemProps {
    name: string
    icon: string
    isActive: boolean
    Child: IChildProps[]
}
interface IUserContentProps {
    isProfileOpen?: boolean
    msgCount?: number
    openMessages?: () => void
    Logout: () => void
}
export default function UserLayout(props: { children: any }) {
    const optionInfo = useSelector((store: any) => store.data.options);
    const start: any = useRef(null)
    const subNavigtion = useSelector((store: any) => store.data.routs);
    const path = useLocation().pathname;
    let navigate = useNavigate();
    const dispatch = useDispatch()
    const [navController, setNavController] = useState({
        isMenuOpen: true,
        isProfileOpen: false,
        msgCount: 0
    })
    const [data, setData] = useState({ wins: [] });
    const end: any = useRef(null)

    let [model, setModel] = useState({
        menuArr: menuData.map(item => ({//احضار الاولاد المسموح فيهم فقط
            ...item,
            Child: item.Child.filter(sub => subNavigtion.find((row: any) => +row.parentId === +sub.id))
        })),
        navigation: [],
        subNavigtion,
        id: 0,
        selectedSecondNodeId: null as number | null,
        hideStartBtn: true,
        hideEndBtn: true,
    });
    const goToStart = () => {
        setModel(old => ({
            ...old,
            hideStartBtn: true,
            hideEndBtn: false,
        }))
        start.current?.scrollIntoView({
            behavior: "smooth"
        })
    }
    const goToEnd = () => {
        setModel(old => ({
            ...old,
            hideStartBtn: false,
            hideEndBtn: true,
        }))
        end.current?.scrollIntoView({
            behavior: "smooth"
        })
    }
    function CheckLogin() {
        var cookieDate = app.getCookie("lastCheckLoginCall", "")
        if (cookieDate !== "") {
            var lastCallTime = new Date(cookieDate)
            var timeFromLastCall = (new Date().getTime() - lastCallTime.getTime()) / 1000;
            if (timeFromLastCall < 10) {
                return;
            }
        }
        app.setCookie("lastCheckLoginCall", new Date().toString(), 1);
        http.get('/Login/CheckLogin', {}, function (res) {
            if (!res.Success) {
                window.location.href = "/";
            }
            else {
                if (res.AdditionalData < 1) {
                    app.showAlert(app.translate("MsgSessionAfterSeconds"), "Warning", () => {
                        window.location.href = "/"
                    }, () => http.get("/Login/SetLang", {
                        lang: app.translate("Lang")
                    }, () => { }));
                }

                setNavController(old => {
                    if (res.CarryOnData) {
                        var audio = new Audio('NewMessage.mp3');
                        audio.play();
                        if (Notification.permission === 'granted') {
                            var notification = new Notification(app.translate("MessageSystem"), {
                                icon: window.location.origin + "/Images/logo.png",
                                body: app.translate("YouhaveNewMessages")
                            });
                            notification.onclick = function () {
                                window.open(window.location.origin + "/MessageSystem");
                            };
                        }
                    }
                    return { ...old, msgCount: +res.Code }
                })
            }
        }, true);
    }

    useEffect(() => {
        CheckLogin();
        setInterval(function () {
            CheckLogin();
        }, 10000);
    }, []);

    function Logout() {
        http.post("/Login/Logout", {}, (res) => {
            dispatch(logout());
            window.open("/", "_self");
        })
    }
    function preparePath(oldPath: string, ulrParam?: string) {
        oldPath = oldPath + (ulrParam ? "/" + ulrParam : "");
        var arr = oldPath.split("/")
        if (arr.length > 3)
            arr.splice(-1)
        return arr.join('')
    }

    useEffect(() => {
        var son = subNavigtion.find((r: any) => preparePath(r.path, r.ulrParam) === preparePath(path));
        if (son !== undefined) {
            var parent: any = menuData.map(row => row.Child.map(q => ({ ...q, parent: row.name }))).flat(1).find(r => r.id === son.parentId)
            if (parent !== undefined)
                setModel(old => ({
                    ...old,
                    navigation: (+parent.name === +son.name ? [parent.parent, parent.name] : [parent.parent, parent.name, son.name]) as any, id: son.parentId
                }))
        }
    }, [path])

    function FNclicked(node: IMenuItemProps,) {
        setModel(old => {
            const isSameNode = old.menuArr.find(item => item.name === node.name)?.isActive;
            return {
                ...old,
                menuArr: old.menuArr.map(item => item.name === node.name ? { ...item, isActive: !isSameNode }
                :{ ...item, isActive: false })
            }
        });
    }
    function SNclicked(Snode: IChildProps) {
        var firstWin = subNavigtion.find((r: any) => +r.parentId === +Snode.id);
        if (firstWin&&firstWin.path === "/Reports") {
            window.open("/Reports")
            return;
        }
        setModel(old => ({
            ...old,
            id: Snode.id,
            selectedSecondNodeId: Snode.id
        }));      
        if (firstWin)
            openPath(firstWin);
    }
    function openPath(item: any) {
        if (item.path === "/Reports") {
            window.open("/Reports")
            return;
        }
        if (model.navigation.length === 3)
            model.navigation.splice(-1)
        setModel(old => ({ ...old, navigation: [...old.navigation, item.name] as any }))
        navigate(item.path + (item.ulrParam ? "/" + item.ulrParam : ""));
    }
    useEffect(() => {
        const timer =setTimeout(() => {
            var x: any = document.getElementById("crumblist")
            if (!x) return
            setModel(old => ({
                ...old,
                hideEndBtn: x.clientWidth >= x.scrollWidth,
                hideStartBtn: true,
            }))
        }, 1000)
        return () => clearTimeout(timer)
    }, [model.id])
    function GetUserShortcuts() {
        http.get("/HelpWin/GetUserShortcuts", {}, (res) => {
              setData((old) => ({
                ...old, wins: res.AdditionalData.map((perm: any) => {
                    var route = subNavigtion.find((r: any) => r.perm === perm.Perm_No);
                    return { ...perm, icon: route && route.icon ? route.icon : "arrow-up-right-from-square" }
                })
              }));
        });
    }
    function openWin(perm: number) {
        var item = subNavigtion.filter((r: any) => r.perm === perm)
        if (item.length > 0)
            window.open(window.location.origin + (item?.[0]?.path + (item?.[0]?.ulrParam ? "/" + item?.[0]?.ulrParam : "")), "_self")
    }

    useEffect(GetUserShortcuts, [])

    //! Function to OpenMessages:
    const openMessages = () => {
        navigate("/MessageSystem");
    }
    const getUsernameData = (username: string) => {
        const name = username.split("-", 1)[0];

        let width;
        if (name.length < 10) width = 50;
        else if (name.length < 15) width = 100;
        else if (name.length < 20) width = 120;
        else if (name.length < 25) width = 150 
        else width = 200;

        return { name, width };
    };
    const { name, width: calculatedWidth } = getUsernameData(app.options().userName);
    return (
        <>
            <Navbar bg="body-tertiary" expand="lg" className="sticky-top shadow-sm border-bottom " style={{ zIndex: 1056 }}>
                <Container fluid>
                    {/* Menu Button */}
                    <button onClick={() => setNavController((old) => ({ ...old, isMenuOpen: !old.isMenuOpen }))} className=" btn bg-body me-3 shadow-sm border-secondary border-1 text-secondary rounded-1"
                        type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" aria-controls="offcanvasWithBothOptions">
                        <span
                            className={`icon-bounce ${navController.isMenuOpen ? "iconssc-close-1" : "iconssc-menu"}`}
                            style={{ transform: navController.isMenuOpen ? "rotate(90deg)" :"rotate(0)" }}
                        ></span>
                    </button>

                    {/* Image Logo */}
                    <Navbar.Brand className="bg-transparent shadow-none">
                        <img src={optionInfo.companyLogo.length === 0 ? "images/logo.png" : "data:image/jpeg;base64," + optionInfo.companyLogo} height="35" alt="Logo" />
                    </Navbar.Brand>

                    {/* User Button */}
                    <button type="button" className="btn bg-primary shadow-sm border-secondary border-1 text-secondary rounded-1 d-block d-lg-none"
                        onClick={() => setNavController((old) => ({ ...old, isProfileOpen: !old.isProfileOpen }))}
                    >
                        <span className={`${navController.isProfileOpen ? 'iconssc-close-1' : 'iconssc-user'} icon-bounce`}
                            style={{ transform: navController.isProfileOpen ? "scale(1.1)" : "scale(1)" }}
                        ></span>
                    </button>
                    {/* Second Navbar Start Here */}
                    <Navbar id="navbarScroll" className="w-100 d-none d-lg-block">
                        <div className="d-flex ">
                            <div className="vr ms-3 me-1 bg-gray-400 d-none d-lg-block"></div>
                            <div style={{ direction: "ltr" }} className="w-100 d-none d-lg-block text-dark-emphasis">
                                <Marquee style={{ height: "35px" }} pauseOnHover direction={app.translate("Lang") !== "ar" ? "left" : "right"}>
                                    {app.options().TapeNews}  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </Marquee>
                            </div>
                            <div className="vr ms-1 me-3 bg-gray-400 d-none d-lg-block"></div>
                            <OverlayTrigger key="bottom" placement="bottom"
                                overlay={
                                    <Tooltip id={`tooltip-bottom`}>
                                        <span className="d-none d-xl-block">
                                            {app.options().userName.split("-").slice(1).join("-")}
                                        </span>
                                        <span className="d-none d-lg-block d-xl-none">
                                            {app.options().userName}
                                        </span>
                                    </Tooltip>
                                }>
                                <Nav.Item role="button" className="d-flex  flex-nowrap align-items-center  show-below-xl border-primary rounded-1">
                                    <Nav.Link eventKey="link-1 " className="text-dark-emphasis " disabled>
                                        <span className="text-primary-emphasis mx-2 iconssc-user"></span>
                                    </Nav.Link>
                                    <Nav.Link eventKey="link-1 " className="text-dark-emphasis d-none d-xl-block" disabled style={{ width: `${calculatedWidth}px` }}>
                                        <small>{name}</small>
                                    </Nav.Link>
                                </Nav.Item>
                            </OverlayTrigger>
                            <div className="d-flex align-items-center">
                                  <MessageCount
                                    position={"top-0 start-0"} iconClass={"text-primary-emphasis"}
                                    className="ms-3" msgCount={navController.msgCount}
                                    openMessages={openMessages} />
                                 <Language />
                                 <ColorMode />
                                <Button class="outline-primary text-primary-emphasis"
                                tooltip="Signout" clicked={Logout} icon="off fw-bold" />
                            </div>
                        </div>
                    </Navbar>
                    {/*Second Navbar End Here*/}
                </Container>
            </Navbar>
           
            {/*Main Content Start Here */}
            <main className="d-xl-flex flex-xl-nowrap w-100 overflow-auto bg-body" style={{ height: 'calc(100vh - 61px)' }}>
                {/* Icon Navbar Start Here */}
                <div className="text-bg-dark d-none d-xl-block sticky-xl-top">
                    <nav id="sidebarMenu" className="icon-sidebar bg-primary-subtle">
                        <div className="position-sticky pt-2">
                            <ul className="nav p-2">
                                <li className="nav-item mb-4">
                                    <Button class="text-light fs-5 rounded" tooltip="main"
                                        clicked={() => window.open(window.location.origin + "/UserDashboard", "_self")}>
                                        <span className="iconssc-home"></span>
                                    </Button>
                                </li>
                                {data.wins.map((r: any, i) => <li key={i} className="nav-item mb-4">
                                    <Button class="text-light fs-5 rounded" tooltip={r.PermStr}
                                        clicked={() => openWin(r.Perm_No)}>
                                        {/*<span className="fa-regular fa-paper-plane"></span>*/}
                                        <span className={"fa-solid fa-" + r.icon}></span>
                                    </Button>
                                </li>)}
                                <li className="nav-item mb-4">
                                    <Button class="text-light fs-5 rounded" tooltip="FrmAddShortCuts"
                                        clicked={() => window.open(window.location.origin + "/Help-Windows/Keyboard", "_self")}>
                                        <span className="fa-solid fa-plus"></span>
                                    </Button>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div> 
                {/* Icon Navbar End Here */}

                {/* Menu Content Start Here */}
                <div className="bd-sidebar sticky-xl-top">
                    <div className={`offcanvas offcanvas-start ${navController.isMenuOpen ? "show" : ""} ${navController.isMenuOpen ? "sticky-xl-top" : ""} pt-3`} 
                       tabIndex={-1} id="bdSidebar" aria-labelledby="bdSidebarOffcanvasLabel">
                            <div className="offcanvas-body pt-1">
                                    {model.menuArr.filter(row => row.Child.length > 0).map((firstNode: IMenuItemProps, index: number) =>
                                        <Dropdown className="mb-3 mx-3 dropdown" key={index} show={firstNode.isActive}>
                                            <Dropdown.Toggle variant={firstNode.isActive ? "primary" : "white"} onClick={() => FNclicked(firstNode)}
                                                className={`${firstNode.isActive ? "text-light-emphasis bg-primary-subtle  " : "text-dark-emphasis"} border-0 d-flex py-0 w-100 max-w-270 rounded-0 rounded-top `} id="dropdown-autoclose-outside">
                                                <span className={`align-self-center mx-2 fs-4 ${firstNode.isActive ? "text-light-emphasis" : "text-primary-emphasis"} ${firstNode.icon}`}></span>
                                                <span className="align-self-center me-auto fw-bold">{app.translate(firstNode.name)}</span>
                                                <span className="align-self-center icofont-location-arrow"></span>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu className="w-100 max-w-270 border-0 position-sticky dropdown-menu-nav p-0" key={index}>
                                                {firstNode.Child.map((secondNode: IChildProps, sindex: number) =>
                                                    <Dropdown.Item data-bs-dismiss="offcanvas" className={`${model.selectedSecondNodeId === secondNode.id ? "bg-primary bg-opacity-50 border border-1 border-primary " : ""} ${sindex > 0 ? "mt-1" : ""} rounded-1`}
                                                        key={`${secondNode.id}+${sindex}`}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            SNclicked(secondNode);
                                                        }}>
                                                        {app.translate(secondNode.name)}
                                                    </Dropdown.Item>
                                              )}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    )}
                            </div>
                    </div>
                </div>
                {/*model.selectedSecondNodeId === secondNode.id*/}
                {/* Menu Content End Here */}
                <div className="flex-grow-1 overflow-auto">

                    {/*User Icon Content Start Here */}
                    <UserContent isProfileOpen={navController.isProfileOpen} msgCount={navController.msgCount} openMessages={openMessages} Logout={Logout} />
                    {/*User Icon Content End Here */}
                    <div className="card bg-body border-0 container-fluid">
                            <div className=" pt-2">
                               <nav aria-label="breadcrumb">
                                  <ol className="breadcrumb mb-0">
                                    {model.navigation.map((nav, index) =>
                                        <li className="h5 text-primary-emphasis fw-bold breadcrumb-item" key={index}>
                                            {app.translate(nav)}
                                        </li>
                                       )}
                                    </ol>
                                </nav>
                                <nav className="breadcrumb-divider-none w-100 position-relative d-inline-block overflow-hidden " aria-label="breadcrumb">
                                   <ol className="breadcrumb d-inline-block text-nowrap mb-0" id="crumblist">
                                       <li ref={start} className="breadcrumb-item d-inline-block"></li>
                                     {!model.hideStartBtn &&
                                           <li className="breadcrumb-item position-sticky start-0 d-inline-block" key="900" >
                                                <Button class="bg-primary border border-1 border-primary rounded-2 shadow-lg" iconClass="text-light" icon={`${app.translate("Lang") === "ar" ? "right" : "left"}-arrow-light`} clicked={goToStart} />
                                           </li>
                                       }
                                       {model.subNavigtion.filter((item: any) => +item.parentId === +model.id).map((nav: any, index: number) =>
                                            <li className="breadcrumb-item d-inline-block " key={index}  >
                                                <button type="button" onClick={() => openPath(nav)} className="btn btn-link px-1">
                                                       {app.translate(nav.name)}
                                                       </button>
                                            </li>
                                        )}

                                    {!model.hideEndBtn &&
                                            <li className="breadcrumb-item position-sticky end-0 d-inline-block " key="901" >
                                                <Button class="bg-primary border border-1 border-primary rounded-2 shadow-lg" iconClass="text-light" icon={`${app.translate("Lang") === "ar" ? "left" : "right"}-arrow-light`} clicked={goToEnd} />
                                            </li>                                    
                                       }
                                        <li ref={end} className="breadcrumb-item d-inline-block"></li>
                                    </ol>                             
                                </nav>
                            </div>
                            <div>{props.children}</div>
                    </div>
                </div>
            </main>
            {/*Main Content End Here */}
       </>
    );
}
//! MessageCount:
const MessageCount = ({ msgCount, openMessages, className, style, iconClass, position }: IMessageCountProps) => {
    return (
        <div className={`position-relative ${className || ""}`} style={style}>
            <Button class={`${iconClass} d-flex align-items-center justify-content-center w-100 h-100`}
                icon="mail"
                tooltip="FrmCorrespondences"
                clicked={openMessages}>
                <span className={`position-absolute ${position} translate-middle badge rounded-pill bg-danger`}>
                    {msgCount.toString()}
                </span>
            </Button>
        </div>
    )
}
//! UserContent:
const UserContent = ({ isProfileOpen, msgCount, openMessages, Logout }: IUserContentProps) => {
    return (
        <div className={`offcanvas offcanvas-end bg-primary z-55 pt-3 ${isProfileOpen ? "show" : ""}`}
            style={{ marginTop: "61px", visibility: isProfileOpen ? "visible" : "hidden" }} >
            <div className="offcanvas-body pt-1">
                <ul className="navbar-nav flex-row flex-wrap bd-navbar-nav">
                    <li className="nav-item col-12 d-flex flex-column gap-4">
                        <div className="fs-4 d-flex flex-column">
                            <span className="text-light">{app.translate("username")} </span>
                            <span className="text-light">{app.options().userName}</span>
                        </div>

                        <div className="d-flex align-items-center justify-content-end gap-2 ms-auto">
                            <div className="border border border-primary bg-dark  bg-opacity-25  rounded-1">
                                <Language isUserMenu />
                            </div>
                            <div className="border border-primary bg-dark  bg-opacity-25 rounded-1">
                                <ColorMode isUserMenu />
                            </div>
                            <MessageCount
                                iconClass="text-primary"
                                position={"top-20 end-50"} style={{ width: "48px", height: "43px" }}
                                className="border border border-primary bg-light rounded-1"
                                msgCount={msgCount!} openMessages={openMessages!} />
                        </div>
                    </li>
                    <li className="nav-item col-12 mt-5">
                        <Button class="btn-light w-100 text-primary fw-medium" label="Signout" clicked={Logout} icon="off fw-bold"></Button>
                    </li>
                </ul>
                <hr className="d-lg-none text-white-50" />
            </div>
        </div>
    );
}